import React, { Component } from "react";
import { connect } from "react-redux";
import Add from "./Add";
import {
  getArticles,
  setCurrentArticle,
} from "../store/actions/categoryArticlesActions";

import { useSelector, useDispatch } from "react-redux";
import { useState, useEffect } from "react";

import {
  filterCategoryArticles,
  sortCategoryArticlesByLevelAndArticleNumber,
} from "../helpers/helpers";
import {
  groupContentByLevel,
  groupBeginnerArticlesBySubcategory,
  mapCategoryToVideoCategory,
} from "../helpers/contentGrouping";
import {
  getBeginnerSubcategoryPresetList,
  getBeginnerSubcategoryAliasMap,
} from "../data/beginner/beginnerArticleSubcategories";
import {
  getLearnSubcategoryPresetList,
  getLearnSubcategoryAliasMap,
} from "../data/learn/declarerArticleSubcategories";
import { isLocalhostBuild } from "../utils/beginnerMode";
import CategoryArticleListItem from "../components/Articles/CategoryArticleListItem";
import VideoCard from "../components/Articles/VideoCard";
import LevelBanner from "../components/Articles/LevelBanner";
import PracticeQuestionBundleCard from "../components/PracticeQuestions/PracticeQuestionBundleCard";
import { getBannerText } from "../services/categoryBannerService";
import { firebase } from "../firebase/config";
import "./CategoryArticles.css";
import FiltersCategoryArticles from "./FiltersCategoryArticles";
import SkeletonLoader from "../components/UI/SkeletonLoader";
import { Helmet } from "react-helmet-async";
import { Button, Row, Col, Card, Icon, TextInput, Select } from "react-materialize";
import { colourSuits } from "../components/UI/SuitText";

const ARTICLE_TOPIC_TABS = [
  { id: "declarer", label: "Declarer", path: "/declarer/articles", types: ["cardPlay"] },
  { id: "defence", label: "Defence", path: "/defence/articles", types: ["defence"] },
  { id: "bidding", label: "Bidding", path: "/bidding/advanced", types: ["bidding", "biddingAdvanced"] },
];
const REVIEW_TOPIC_TAB = { id: "review", label: "Review", path: "/learn/review", types: [] };
const BEGINNER_ARTICLE_TOPIC_TABS = [
  {
    id: "declarer",
    label: "Declarer",
    path: "/beginner/articles/declarer",
    types: ["beginnerCardPlay"],
  },
  {
    id: "defence",
    label: "Defence",
    path: "/beginner/articles/defence",
    types: ["beginnerDefence"],
  },
  {
    id: "bidding",
    label: "Bidding",
    path: "/beginner/articles/bidding",
    types: ["beginnerBidding"],
  },
];

const BEGINNER_CATEGORY_SEO = {
  beginnerCardPlay: {
    title: "Bridge Declarer Play for Beginners | Bridge Champions",
    description:
      "Learn declarer play in bridge with beginner-friendly lessons on drawing trumps, finesses, and creating extra winners.",
    h1: "Bridge Declarer Play for Beginners",
    subtitle:
      "Step-by-step declarer lessons for new players: trump management, finesses, and notrump planning.",
    roadmap: [
      "Start with trump management and simple hand-planning.",
      "Add finesses and honor-combination judgment.",
      "Then learn to establish side-suit winners consistently.",
    ],
  },
  beginnerDefence: {
    title: "Bridge Defence for Beginners | Bridge Champions",
    description:
      "Beginner bridge defence lessons on opening leads, second hand low, third hand high, and practical defensive partnership habits.",
    h1: "Bridge Defence for Beginners",
    subtitle:
      "Beginner defence made practical: opening leads, second hand low, third hand high, and clear partner communication.",
    roadmap: [
      "Start with opening leads and lead-planning basics.",
      "Build second hand low and third hand high habits.",
      "Then improve with lead-through-strength and lead-towards-weakness judgment.",
    ],
  },
  beginnerBidding: {
    title: "Bridge Bidding for Beginners | Bridge Champions",
    description:
      "Bridge bidding basics for beginners: opening bids, responder's first bid, opener rebids, and clear 1NT agreements.",
    h1: "Bridge Bidding for Beginners",
    subtitle:
      "Learn beginner bidding from first principles: opening bids, responder priorities, opener rebids, and 1NT structure.",
    roadmap: [
      "Start with opening bids and minimum hand-evaluation rules.",
      "Then master responder's first bid and fit-first decisions.",
      "Finish with opener rebids and disciplined 1NT agreements.",
    ],
  },
};

const getArticlePathByType = (type, id) => {
  if (type === "counting") return `/counting/articles/${id}`;
  if (type === "cardPlay") return `/declarer/articles/${id}`;
  if (type === "beginnerCardPlay") return `/beginner/articles/declarer/${id}`;
  if (type === "beginnerDefence") return `/beginner/articles/defence/${id}`;
  if (type === "beginnerBidding") return `/beginner/articles/bidding/${id}`;
  if (type === "defence") return `/defence/articles/${id}`;
  if (type === "biddingBasics") return `/bidding/basics/${id}`;
  if (type === "biddingAdvanced") return `/bidding/advanced/${id}`;
  if (type === "cardPlayBasics") return `/declarer/basics/${id}`;
  if (type === "defenceBasics") return `/defence/basics/${id}`;
  if (type === "bidding") return `/bidding/advanced/${id}`;
  return `/${type}/${id}`;
};

const CategoryArticles = ({ articleType, history, dontNavigate, location }) => {
  const pageNumber = Number(location.search.split("e")[1]);

  const [page, setPage] = useState(pageNumber ? pageNumber : 1);
  const [bannerTexts, setBannerTexts] = useState({});
  const [videos, setVideos] = useState([]);
  const [videosLoading, setVideosLoading] = useState(true);
  const [practiceQuestions, setPracticeQuestions] = useState([]);
  const [practiceQuestionsLoading, setPracticeQuestionsLoading] = useState(true);
  const [showVideoForm, setShowVideoForm] = useState(false);
  const [newVideo, setNewVideo] = useState({
    title: '',
    url: '',
    description: '',
    difficulty: '1'
  });
  const [submittingVideo, setSubmittingVideo] = useState(false);
  const articles = useSelector(
    (state) => state.categoryArticles?.[articleType]
  );
  const a = useSelector((state) => state.auth.a);
  const subscriptionActive = useSelector((state) => state.auth.subscriptionActive);
  const uid = useSelector((state) => state.auth.uid);
  
  // Debug: Log admin and subscription status
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      console.log('CategoryArticles - Admin (a):', a, 'Type:', typeof a, 'Subscription Active:', subscriptionActive);
    }
  }, [a, subscriptionActive]);
  const filters = useSelector((state) => state.filters);
  const dispatch = useDispatch();

  useEffect(() => {
    if (articles === undefined || articles?.length === 0) {
      dispatch(getArticles(articleType));
    }
  }, []);

  useEffect(() => {
    if (articles === undefined || articles?.length === 0) {
      dispatch(getArticles(articleType));
    }
  }, [articleType]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [articleType]);

  // Fetch videos for this category
  useEffect(() => {
    const videoCategory = mapCategoryToVideoCategory(articleType);
    setVideosLoading(true);
    
    const unsubscribe = firebase.firestore()
      .collection('videos')
      .where('category', '==', videoCategory)
      .onSnapshot(
        (snapshot) => {
          const videosList = [];
          snapshot.forEach((doc) => {
            const videoData = { id: doc.id, ...doc.data() };
            videosList.push(videoData);
            // Log for debugging
            if (process.env.NODE_ENV === 'development') {
              console.log('Fetched video:', videoData.title, 'Category:', videoData.category, 'Difficulty:', videoData.difficulty);
            }
          });
          // Sort by createdAt descending (newest first)
          videosList.sort((a, b) => {
            const dateA = a?.createdAt?.toDate ? a.createdAt.toDate() : new Date(a?.createdAt || 0);
            const dateB = b?.createdAt?.toDate ? b.createdAt.toDate() : new Date(b?.createdAt || 0);
            return dateB - dateA;
          });
          setVideos(videosList);
          setVideosLoading(false);
        },
        (error) => {
          console.error('Error fetching videos:', error);
          setVideos([]);
          setVideosLoading(false);
        }
      );

    return () => unsubscribe();
  }, [articleType]);

  const setCurrentArticleAndGoTo = (article, id) => {
    if (dontNavigate) {
      return;
    }
    dispatch(setCurrentArticle(article));
    // Prefer the readable slug for the URL; fall back to the body id.
    const seg = article?.slug || id;
    const nextPath = getArticlePathByType(articleType, seg);
    history.push(nextPath);
  };

  // Video form helpers
  const getYouTubeEmbedUrl = (url) => {
    let videoId = '';
    if (url.includes('youtube.com/watch?v=')) {
      videoId = url.split('watch?v=')[1].split('&')[0];
    } else if (url.includes('youtu.be/')) {
      videoId = url.split('youtu.be/')[1].split('?')[0];
    } else if (url.includes('youtube.com/embed/')) {
      return url;
    }
    return videoId ? `https://www.youtube.com/embed/${videoId}` : url;
  };

  const handleVideoInputChange = (e) => {
    const { name, value } = e.target;
    setNewVideo(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleVideoSubmit = async (e) => {
    e.preventDefault();
    
    if (!newVideo.title || !newVideo.url) {
      alert('Please fill in title and URL');
      return;
    }

    setSubmittingVideo(true);

    const videoCategory = mapCategoryToVideoCategory(articleType);
    const videoData = {
      title: newVideo.title,
      url: getYouTubeEmbedUrl(newVideo.url),
      description: newVideo.description,
      category: videoCategory,
      difficulty: newVideo.difficulty || '1',
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
      createdBy: uid || 'anonymous'
    };

    try {
      await firebase.firestore().collection('videos').add(videoData);
      setNewVideo({ title: '', url: '', description: '', difficulty: '1' });
      setShowVideoForm(false);
      alert('Video added successfully!');
    } catch (error) {
      console.error('Error adding video:', error);
      alert('Error adding video. Please try again.');
    } finally {
      setSubmittingVideo(false);
    }
  };

  const handleDeleteVideo = async (videoId) => {
    try {
      await firebase.firestore().collection('videos').doc(videoId).delete();
      alert('Video deleted successfully!');
    } catch (error) {
      console.error('Error deleting video:', error);
      alert('Error deleting video. Please try again.');
    }
  };

  // Fetch practice questions for this category
  useEffect(() => {
    setPracticeQuestionsLoading(true);
    
    const summaryRef = firebase.firestore().collection(articleType);
    const bodyRef = firebase.firestore().collection(articleType + 'Body');
    
    const unsubscribe = summaryRef
      .where('contentType', '==', 'practiceQuestions')
      .onSnapshot(
        async (snapshot) => {
          const bundles = [];
          const fetchPromises = [];
          
          snapshot.forEach((doc) => {
            const data = { id: doc.id, ...doc.data() };
            
            // Fetch body to get question count
            if (data.body) {
              fetchPromises.push(
                bodyRef.doc(data.body).get().then((bodyDoc) => {
                  if (bodyDoc.exists) {
                    const bodyData = bodyDoc.data();
                    const questions = bodyData.questions || [];
                    return { ...data, questionCount: questions.length };
                  }
                  return { ...data, questionCount: 0 };
                }).catch(() => {
                  return { ...data, questionCount: 0 };
                })
              );
            } else {
              bundles.push({ ...data, questionCount: 0 });
            }
          });
          
          // Wait for all body fetches
          const results = await Promise.all(fetchPromises);
          bundles.push(...results);
          
          // Sort by articleNumber
          bundles.sort((a, b) => {
            const numA = Number(a?.articleNumber || 0);
            const numB = Number(b?.articleNumber || 0);
            return numA - numB;
          });
          
          setPracticeQuestions(bundles);
          setPracticeQuestionsLoading(false);
        },
        (error) => {
          console.error('Error fetching practice questions:', error);
          setPracticeQuestions([]);
          setPracticeQuestionsLoading(false);
        }
      );

    return () => unsubscribe();
  }, [articleType]);

  // Group articles, videos, and practice questions by level for banner display.
  // Drop hidden drafts and post-merge redirect stubs from the category list —
  // hidden drafts live in /pillars; redirect stubs only exist to bounce
  // inbound traffic to a primary URL.
  const visibleArticles = (articles || []).filter((a) => {
    if (!a) return false;
    if (a.isHidden === true) return false;
    if (typeof a.redirectTo === "string" && a.redirectTo.startsWith("/")) return false;
    return true;
  });
  const sortedArticles = sortCategoryArticlesByLevelAndArticleNumber(visibleArticles);
  const filteredArticles = filterCategoryArticles(sortedArticles, filters);
  const groupedContent = groupContentByLevel(
    filteredArticles || [],
    videos || [],
    practiceQuestions || []
  );

  const beginnerSubcategoryPreset = getBeginnerSubcategoryPresetList(articleType);
  const learnSubcategoryPreset = getLearnSubcategoryPresetList(articleType);
  const activeSubcategoryPreset = beginnerSubcategoryPreset || learnSubcategoryPreset;
  const beginnerSubcategoryAliases = getBeginnerSubcategoryAliasMap(articleType);
  const learnSubcategoryAliases = getLearnSubcategoryAliasMap(articleType);
  const activeSubcategoryAliases = {
    ...(learnSubcategoryAliases || {}),
    ...(beginnerSubcategoryAliases || {}),
  };
  const normalizeSubcategoryLabel = (value = "") =>
    String(value)
      .trim()
      .replace(/[’`]/g, "'")
      .toLowerCase()
      .replace(/\.+$/g, "")
      .replace(/\s+/g, " ");
  const normalizedAliasMap = Object.entries(activeSubcategoryAliases || {}).reduce(
    (acc, [from, to]) => {
      const key = normalizeSubcategoryLabel(from);
      if (key) acc[key] = to;
      return acc;
    },
    {}
  );
  const normalizedSubcategoryArticles =
    activeSubcategoryPreset && filteredArticles != null
      ? filteredArticles.map((article) => {
          const originalSub = (article?.subcategory || "").trim();
          const canonicalSub = normalizedAliasMap[normalizeSubcategoryLabel(originalSub)];
          if (!canonicalSub) return article;
          return { ...article, subcategory: canonicalSub };
        })
      : filteredArticles;
  const subtopicSections =
    activeSubcategoryPreset && normalizedSubcategoryArticles != null
      ? groupBeginnerArticlesBySubcategory(
          normalizedSubcategoryArticles,
          [...activeSubcategoryPreset]
        )
      : null;

  // Get category info
  const getCreatePath = () => {
    if (articleType === "beginnerCardPlay") return "/create/beginner/declarer";
    if (articleType === "beginnerDefence") return "/create/beginner/defence";
    if (articleType === "beginnerBidding") return "/create/beginner/bidding";
    if (articleType === "biddingBasics") return "/create/bidding/basics";
    if (articleType === "bidding") return "/create/bidding";
    if (articleType === "cardPlayBasics") return "/create/cardPlay/basics";
    if (articleType === "defenceBasics") return "/create/defence/basics";
    return `/create/${articleType}`;
  };

  const showComingSoon = false;

  const getCategoryInfo = () => {
    switch (articleType) {
      case 'defence':
        return { name: 'Defence', subtitle: 'Master defensive play' };
      case 'cardPlay':
        return { name: 'Declarer Play', subtitle: 'Skilled declarer play comes from simple counting and basic pattern recognition' };
      case 'bidding':
        return { name: 'Bidding – Articles & explanations', subtitle: 'Deeper concepts and expert-level bidding judgment.' };
      case 'biddingBasics':
        return { name: 'Bidding – Improve your fundamentals', subtitle: 'Critically important to get this right. Build a solid foundation.' };
      case 'biddingAdvanced':
        return { name: 'Bidding – Articles & explanations', subtitle: 'Deeper concepts and expert-level bidding judgment.' };
      case 'counting':
        return { name: 'Counting', subtitle: 'Articles and videos to support the Counting practice hands' };
      case 'beginnerCardPlay':
        return {
          name: BEGINNER_CATEGORY_SEO.beginnerCardPlay.h1,
          subtitle: BEGINNER_CATEGORY_SEO.beginnerCardPlay.subtitle,
        };
      case 'beginnerDefence':
        return {
          name: BEGINNER_CATEGORY_SEO.beginnerDefence.h1,
          subtitle: BEGINNER_CATEGORY_SEO.beginnerDefence.subtitle,
        };
      case 'beginnerBidding':
        return {
          name: BEGINNER_CATEGORY_SEO.beginnerBidding.h1,
          subtitle: BEGINNER_CATEGORY_SEO.beginnerBidding.subtitle,
        };
      default: 
        return { name: articleType, subtitle: 'Expert bridge articles and analysis' };
    }
  };

  const categoryInfo = getCategoryInfo();
  const isBeginnerArticleType = articleType?.startsWith("beginner");
  const standardTopicTabs = isLocalhostBuild()
    ? [...ARTICLE_TOPIC_TABS, REVIEW_TOPIC_TAB]
    : ARTICLE_TOPIC_TABS;
  const showDualLearnTopicNav = true;
  const activeAdvancedTopicId =
    standardTopicTabs.find((tab) => tab.types.includes(articleType))?.id || "";
  const activeBeginnerTopicId =
    BEGINNER_ARTICLE_TOPIC_TABS.find((tab) => tab.types.includes(articleType))?.id || "";
  const beginnerStarterArticles = isBeginnerArticleType ? sortedArticles.slice(0, 3) : [];
  const beginnerRoadmap = BEGINNER_CATEGORY_SEO[articleType]?.roadmap || [];

  // Fetch banner texts for all levels when content changes
  useEffect(() => {
    if (groupedContent.length === 0) {
      setBannerTexts({});
      return;
    }

    const fetchBannerTexts = async () => {
      const texts = {};
      const levels = groupedContent.map(g => g.level);
      
      for (const level of levels) {
        try {
          const text = await getBannerText(articleType, level);
          texts[level] = text;
        } catch (error) {
          console.error(`Error fetching banner for level ${level}:`, error);
          // Use fallback text on error
          texts[level] = level === '1' ? 'Start here - Learn the patterns' : `Level ${level}`;
        }
      }
      setBannerTexts(texts);
    };

    fetchBannerTexts();
  }, [articleType, groupedContent.length]);

  // Render articles and videos grouped by level with banners
  let contentJSX;
  if (groupedContent.length > 0) {
    contentJSX = groupedContent.map((group, groupIdx) => {
      const bannerText = bannerTexts[group.level] || `Level ${group.level}`;
      const hasContent = (group.articles?.length > 0) || (group.videos?.length > 0);
      
      if (!hasContent) return null;
      
      return (
        <div key={`level-${group.level}`} className="CategoryArticles-level-group">
          <LevelBanner 
            text={bannerText} 
            level={group.level}
            category={articleType}
            categoryName={categoryInfo.name}
            onUpdate={() => {
              // Refetch banner texts when updated
              const fetchBannerTexts = async () => {
                const texts = {};
                const levels = groupedContent.map(g => g.level);
                for (const level of levels) {
                  try {
                    const text = await getBannerText(articleType, level);
                    texts[level] = text;
                  } catch (error) {
                    texts[level] = level === '1' ? 'Start here - Learn the patterns' : `Level ${level}`;
                  }
                }
                setBannerTexts(texts);
              };
              fetchBannerTexts();
            }}
          />
          <div className="CategoryArticles-grid">
            {/* Render articles */}
            {group.articles.map((article) => (
              <CategoryArticleListItem
                key={article.id}
                createdAt={article.createdAt}
                body={article.body}
                category={article.category}
                difficulty={article.difficulty}
                articleNumber={article.articleNumber}
                id={article.id}
                slug={article.slug}
                teaser={article.teaser}
                teaser_board={article.teaser_board}
                title={article.title}
                router={history}
                a={a}
                subscriptionActive={subscriptionActive}
                hasVideo={article.hasVideo === true}
                isFree={article.isFree === true}
                clickHandler={setCurrentArticleAndGoTo}
                articleType={articleType}
              />
            ))}
            {/* Render videos */}
            {group.videos.map((video) => (
              <VideoCard
                key={video.id}
                id={video.id}
                title={video.title}
                url={video.url}
                description={video.description}
                createdAt={video.createdAt}
                difficulty={video.difficulty || '1'}
                a={a}
                subscriptionActive={subscriptionActive}
                onDelete={a === true ? handleDeleteVideo : undefined}
              />
            ))}
          </div>
          
          {/* Practice Questions Section */}
          {group.practiceQuestions && group.practiceQuestions.length > 0 && (
            <div className="CategoryArticles-practice-questions-section">
              <h2 className="CategoryArticles-practice-questions-header">
                Practice Questions
              </h2>
              <div className="CategoryArticles-grid">
                {group.practiceQuestions.map((bundle) => (
                  <PracticeQuestionBundleCard
                    key={bundle.id}
                    id={bundle.id}
                    title={bundle.title}
                    teaser={bundle.teaser}
                    difficulty={bundle.difficulty}
                    articleNumber={bundle.articleNumber}
                    questionCount={bundle.questionCount || 0}
                    clickHandler={(id) => {
                      history.push(`/practice-questions/${id}`);
                    }}
                    a={a}
                    subscriptionActive={subscriptionActive}
                  />
                ))}
              </div>
            </div>
          )}
        </div>
      );
    });
  }

  const getCategoryTitle = () => {
    if (BEGINNER_CATEGORY_SEO[articleType]?.title) {
      return BEGINNER_CATEGORY_SEO[articleType].title;
    }
    return `${categoryInfo.name} Articles - Bridge Champions`;
  };

  const getCategoryDescription = () => {
    if (BEGINNER_CATEGORY_SEO[articleType]?.description) {
      return BEGINNER_CATEGORY_SEO[articleType].description;
    }
    return `${categoryInfo.subtitle}. Browse our collection of expert ${categoryInfo.name.toLowerCase()} articles and improve your Bridge game.`;
  };

  const categoryPathMap = {
    cardPlay: "/declarer/articles",
    cardPlayBasics: "/declarer/articles",
    defence: "/defence/articles",
    defenceBasics: "/defence/articles",
    bidding: "/bidding/advanced",
    biddingAdvanced: "/bidding/advanced",
    biddingBasics: "/bidding/basics",
    counting: "/declarer/articles",
    beginnerCardPlay: "/beginner/articles/declarer",
    beginnerDefence: "/beginner/articles/defence",
    beginnerBidding: "/beginner/articles/bidding",
  };
  const categoryHubPathMap = {
    cardPlay: "/declarer",
    cardPlayBasics: "/declarer",
    defence: "/defence",
    defenceBasics: "/defence",
    bidding: "/bidding",
    biddingAdvanced: "/bidding",
    biddingBasics: "/bidding",
    counting: "/counting",
    beginnerCardPlay: "/beginner",
    beginnerDefence: "/beginner",
    beginnerBidding: "/beginner",
  };

  const getCategoryUrl = () => {
    const baseUrl = "https://bridgechampions.com";
    return `${baseUrl}${categoryPathMap[articleType] || "/"}`;
  };
  const breadcrumbItems = (() => {
    if (isBeginnerArticleType) {
      return [
        { name: "Home", path: "/" },
        { name: "Fundamentals", path: "/beginner" },
        { name: `${categoryInfo.name} Articles`, path: categoryPathMap[articleType] || "/" },
      ];
    }
    return [
      { name: "Home", path: "/" },
      { name: categoryInfo.name, path: categoryHubPathMap[articleType] || "/" },
      { name: `${categoryInfo.name} Articles`, path: categoryPathMap[articleType] || "/" },
    ];
  })();
  const collectionStructuredData = {
    "@context": "https://schema.org",
    "@type": "CollectionPage",
    name: getCategoryTitle(),
    description: getCategoryDescription(),
    url: getCategoryUrl(),
    inLanguage: "en",
    isPartOf: {
      "@type": "WebSite",
      name: "Bridge Champions",
      url: "https://bridgechampions.com",
    },
    mainEntity: {
      "@type": "ItemList",
      numberOfItems: (filteredArticles || []).length,
      itemListElement: (filteredArticles || []).slice(0, 25).map((item, idx) => ({
        "@type": "ListItem",
        position: idx + 1,
        url: `${getCategoryUrl()}/${item.id}`,
        name: item.title || `Article ${idx + 1}`,
      })),
    },
  };
  const breadcrumbStructuredData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: breadcrumbItems.map((item, idx) => ({
      "@type": "ListItem",
      position: idx + 1,
      name: item.name,
      item: `https://bridgechampions.com${item.path}`,
    })),
  };

  return (
    <div className="CategoryArticles">
      <Helmet>
        <title>{getCategoryTitle()}</title>
        <meta name="description" content={getCategoryDescription()} />
        <link rel="canonical" href={getCategoryUrl()} />
        <meta property="og:url" content={getCategoryUrl()} />
        <meta property="og:title" content={getCategoryTitle()} />
        <meta property="og:description" content={getCategoryDescription()} />
        <script type="application/ld+json">
          {JSON.stringify(collectionStructuredData)}
        </script>
        <script type="application/ld+json">
          {JSON.stringify(breadcrumbStructuredData)}
        </script>
      </Helmet>
      {/* Admin Action Buttons */}
      {a === true && (
        <div className="CategoryArticles-admin-buttons">
          {/* Add Practice Questions Button */}
          <div>
            <Button
              floating
              large
              className="purple darken-2"
              onClick={() => history.push(`/create-practice-questions/${articleType}`)}
              waves="light"
            >
              <Icon>quiz</Icon>
            </Button>
            <span className="CategoryArticles-button-label">Add Practice Questions</span>
          </div>

          {/* Add Video Button */}
          <div>
            <Button
              floating
              large
              className="red darken-2"
              onClick={() => setShowVideoForm(!showVideoForm)}
              waves="light"
            >
              <Icon>videocam</Icon>
            </Button>
            <span className="CategoryArticles-button-label">Add Video</span>
          </div>
          
          {/* Add Article Button */}
          <div>
            <Button
              onClick={(e) => history.push(getCreatePath())}
              floating
              large
              className="green darken-2"
              waves="light"
            >
              <Icon>add</Icon>
            </Button>
            <span className="CategoryArticles-button-label">Add Article</span>
          </div>
        </div>
      )}
      
      {/* Fallback: Show Add component if not admin (for other pages) - hide for Coming Soon basics */}
      {a !== true && !showComingSoon && <Add goto={getCreatePath()} history={history} />}

      <div className="CategoryArticles-header">
        <div className="container">
          <div
            className="CategoryArticles-breadcrumbs"
            role="navigation"
            aria-label="Breadcrumb"
          >
            {breadcrumbItems.map((item, idx) => (
              <React.Fragment key={`${item.name}-${idx}`}>
                <a href={item.path}>{colourSuits(item.name)}</a>
                {idx < breadcrumbItems.length - 1 ? (
                  <span className="CategoryArticles-breadcrumb-sep" aria-hidden="true">
                    /
                  </span>
                ) : null}
              </React.Fragment>
            ))}
          </div>
          <h1 className="CategoryArticles-title">{colourSuits(categoryInfo.name)}</h1>
          <p className="CategoryArticles-subtitle">
            {colourSuits(categoryInfo.subtitle)}
          </p>
        </div>
      </div>

      <div className="CategoryArticles-topicNavWrap">
        <div className="container">
          <div className="CategoryArticles-topicNavRow">
            <div className="CategoryArticles-topicNavStack">
              <div className="CategoryArticles-topicNavGroup">
                <div className="CategoryArticles-topicNavLabel">Advanced</div>
                <div className="CategoryArticles-topicNav" role="tablist" aria-label="Advanced article topics">
                  {standardTopicTabs.map((tab) => (
                    <button
                      key={`advanced-${tab.id}`}
                      type="button"
                      role="tab"
                      aria-selected={activeAdvancedTopicId === tab.id}
                      className={`CategoryArticles-topicPill ${
                        activeAdvancedTopicId === tab.id ? "CategoryArticles-topicPill--active" : ""
                      }`}
                      onClick={() => history.push(tab.path)}
                    >
                      {colourSuits(tab.label)}
                    </button>
                  ))}
                </div>
              </div>
              <div className="CategoryArticles-topicNavGroup">
                <div className="CategoryArticles-topicNavLabel">Fundamentals</div>
                <div className="CategoryArticles-topicNav" role="tablist" aria-label="Fundamentals article topics">
                  {BEGINNER_ARTICLE_TOPIC_TABS.map((tab) => (
                    <button
                      key={`beginner-${tab.id}`}
                      type="button"
                      role="tab"
                      aria-selected={activeBeginnerTopicId === tab.id}
                      className={`CategoryArticles-topicPill ${
                        activeBeginnerTopicId === tab.id ? "CategoryArticles-topicPill--active" : ""
                      }`}
                      onClick={() => history.push(tab.path)}
                    >
                      {colourSuits(tab.label)}
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isBeginnerArticleType && (
        <section className="CategoryArticles-beginnerGuide container" aria-label="Beginner learning path">
          <h2 className="CategoryArticles-beginnerGuideTitle">Start here: beginner learning path</h2>
          {beginnerRoadmap.length > 0 && (
            <ul className="CategoryArticles-beginnerGuidePoints">
              {beginnerRoadmap.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
          )}
          {beginnerStarterArticles.length > 0 && (
            <div className="CategoryArticles-beginnerStarterRow">
              {beginnerStarterArticles.map((article, idx) => (
                <button
                  key={`starter-${article.id || idx}`}
                  type="button"
                  className="CategoryArticles-beginnerStarterBtn"
                  onClick={() => setCurrentArticleAndGoTo(article, article.id)}
                >
                  {`Step ${idx + 1}: ${article.title || `Article ${idx + 1}`}`}
                </button>
              ))}
            </div>
          )}
        </section>
      )}

      {showComingSoon && (
        <div className="CategoryArticles-coming-soon container" style={{ textAlign: "center", padding: "4rem 2rem", maxWidth: "36rem", margin: "0 auto" }}>
          <div style={{ fontSize: "3rem", marginBottom: "1rem" }} aria-hidden="true">🚧</div>
          <h2 style={{ fontSize: "1.75rem", marginBottom: "0.75rem", color: "#0F4C3A" }}>Coming Soon</h2>
          <p style={{ fontSize: "1.1rem", color: "#555", lineHeight: 1.6 }}>
            We’re building a dedicated <strong>Improve your fundamentals</strong> section here. Check back later for focused, foundational content.
          </p>
        </div>
      )}

      {!showComingSoon && (
      <>
      <div className="CategoryArticles-filters-section">
        <div className="container">
          <FiltersCategoryArticles />
          
          {/* Add Video Form */}
          {showVideoForm && a === true && (
            <Row style={{ marginTop: '2rem' }}>
              <Col s={12} m={10} l={8} offset="m1 l2">
                <Card>
                  <h5>Add New Video</h5>
                  <form onSubmit={handleVideoSubmit}>
                    <Row>
                      <Col s={12}>
                        <TextInput
                          s={12}
                          label="Video Title"
                          name="title"
                          value={newVideo.title}
                          onChange={handleVideoInputChange}
                          required
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col s={12}>
                        <TextInput
                          s={12}
                          label="YouTube URL"
                          name="url"
                          value={newVideo.url}
                          onChange={handleVideoInputChange}
                          required
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col s={12} m={6}>
                        <Select
                          s={12}
                          label="Difficulty Level"
                          name="difficulty"
                          value={newVideo.difficulty}
                          onChange={handleVideoInputChange}
                        >
                          <option value="1">Level 1</option>
                          <option value="2">Level 2</option>
                          <option value="3">Level 3</option>
                          <option value="4">Level 4</option>
                          <option value="5">Level 5</option>
                        </Select>
                      </Col>
                    </Row>
                    <Row>
                      <Col s={12}>
                        <label htmlFor="video-description">Description</label>
                        <textarea
                          id="video-description"
                          name="description"
                          value={newVideo.description}
                          onChange={handleVideoInputChange}
                          rows="4"
                          style={{ border: '1px solid #9e9e9e', padding: '10px', width: '100%', fontFamily: 'inherit' }}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col s={12} className="center-align">
                        <Button waves="light" type="submit" disabled={submittingVideo}>
                          {submittingVideo ? 'Adding...' : 'Add Video'}
                          <Icon left>save</Icon>
                        </Button>
                        <Button
                          waves="light"
                          style={{ marginLeft: '1rem' }}
                          onClick={() => {
                            setShowVideoForm(false);
                            setNewVideo({ title: '', url: '', description: '', difficulty: '1' });
                          }}
                        >
                          Cancel
                        </Button>
                      </Col>
                    </Row>
                  </form>
                </Card>
              </Col>
            </Row>
          )}
        </div>
      </div>

      <div className="CategoryArticles-content">
        <div className="container">
          {articles === undefined || videosLoading ? (
            <div className="CategoryArticles-grid">
              <SkeletonLoader type="card" count={6} />
            </div>
          ) : subtopicSections ? (
            <div className="CategoryArticles-level-groups CategoryArticles--subtopics">
              {subtopicSections.map((section) => (
                <div
                  key={section.label}
                  className="CategoryArticles-subtopic-section"
                >
                  <h2 className="CategoryArticles-subtopic-heading">{colourSuits(section.label)}</h2>
                  {(() => {
                    const injectReversesCard =
                      (articleType === "bidding" || articleType === "biddingAdvanced") &&
                      section.label === "Conventions and Artificial Methods" &&
                      !section.articles.some((article) => article?.id === "reverses");
                    const sectionArticles = injectReversesCard
                      ? [
                          {
                            id: "reverses",
                            body: "reverses",
                            category: "bidding",
                            difficulty: "3",
                            articleNumber: "19",
                            title: "Reverses in Bridge: How to Identify, Bid, and Respond",
                            teaser:
                              "A practical guide to identifying true reverses, responding with weak hands, and handling competition.",
                            createdAt: new Date().toISOString(),
                            isFree: true,
                          },
                          ...section.articles,
                        ]
                      : section.articles;

                    return sectionArticles.length === 0 ? (
                    <p className="CategoryArticles-subtopic-empty">Articles coming soon.</p>
                  ) : (
                    <div className="CategoryArticles-grid">
                      {sectionArticles.map((article) => (
                        <CategoryArticleListItem
                          key={article.id}
                          createdAt={article.createdAt}
                          body={article.body}
                          category={article.category}
                          difficulty={article.difficulty}
                          articleNumber={article.articleNumber}
                          id={article.id}
                          slug={article.slug}
                          teaser={article.teaser}
                          teaser_board={article.teaser_board}
                          title={article.title}
                          router={history}
                          a={a}
                          subscriptionActive={subscriptionActive}
                          hasVideo={article.hasVideo === true}
                          isFree={article.isFree === true}
                          clickHandler={setCurrentArticleAndGoTo}
                          articleType={articleType}
                        />
                      ))}
                    </div>
                    );
                  })()}
                </div>
              ))}
              {groupedContent.map((group, groupIdx) => {
                const hasSupplemental =
                  (group.videos?.length > 0) ||
                  (group.practiceQuestions?.length > 0);
                if (!hasSupplemental) return null;
                const bannerText = bannerTexts[group.level] || `Level ${group.level}`;
                return (
                  <div
                    key={`beginner-supp-${group.level}-${groupIdx}`}
                    className="CategoryArticles-level-group"
                  >
                    <LevelBanner
                      text={bannerText}
                      level={group.level}
                      category={articleType}
                      categoryName={categoryInfo.name}
                      onUpdate={() => {
                        const fetchBannerTexts = async () => {
                          const texts = {};
                          const levels = groupedContent.map((g) => g.level);
                          for (const level of levels) {
                            try {
                              const text = await getBannerText(articleType, level);
                              texts[level] = text;
                            } catch (error) {
                              texts[level] =
                                level === "1"
                                  ? "Start here - Learn the patterns"
                                  : `Level ${level}`;
                            }
                          }
                          setBannerTexts(texts);
                        };
                        fetchBannerTexts();
                      }}
                    />
                    <div className="CategoryArticles-grid">
                      {group.videos.map((video) => (
                        <VideoCard
                          key={video.id}
                          id={video.id}
                          title={video.title}
                          url={video.url}
                          description={video.description}
                          createdAt={video.createdAt}
                          difficulty={video.difficulty || "1"}
                          a={a}
                          subscriptionActive={subscriptionActive}
                          onDelete={a === true ? handleDeleteVideo : undefined}
                        />
                      ))}
                    </div>
                    {group.practiceQuestions && group.practiceQuestions.length > 0 && (
                      <div className="CategoryArticles-practice-questions-section">
                        <h2 className="CategoryArticles-practice-questions-header">
                          Practice Questions
                        </h2>
                        <div className="CategoryArticles-grid">
                          {group.practiceQuestions.map((bundle) => (
                            <PracticeQuestionBundleCard
                              key={bundle.id}
                              id={bundle.id}
                              title={bundle.title}
                              teaser={bundle.teaser}
                              difficulty={bundle.difficulty}
                              articleNumber={bundle.articleNumber}
                              questionCount={bundle.questionCount || 0}
                              clickHandler={(id) => {
                                history.push(`/practice-questions/${id}`);
                              }}
                              a={a}
                              subscriptionActive={subscriptionActive}
                            />
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          ) : groupedContent.length > 0 ? (
            <div className="CategoryArticles-level-groups">
              {contentJSX}
            </div>
          ) : (
            <div className="CategoryArticles-empty">
              <p>No content found matching your filters.</p>
              <p>Try adjusting your difficulty level filter.</p>
            </div>
          )}
        </div>
      </div>

      </>
      )}

    </div>
  );
};

export default CategoryArticles;
